import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { Link as RouterLink } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import { ReactComponent as GoogleCalendarIcon } from 'images/icons/google-calendar-colored.svg'
import SettingsBox from 'components/coach-settings-box'
import SyncedCalendarPicker from './synced-calendar-picker'

const GET_CURRENT_USER_CALENDAR_CONNECTED_STATUS = gql`
  query GetCurrentUserCalendarConnectedStatus {
    currentUser {
      attributes {
        ... on Coach {
          googleCalendarConnected
        }
      }
    }
  }
`

const GoogleCalendarIntegration = ({
  googleCalendarConnected,
  onIntegrationChange,
}) => {
  const actionManage = (
    <Button
      variant="outlined"
      color="primary"
      component={RouterLink}
      to="../settings/google-calendar"
      style={{
        marginLeft: 'auto',
        marginRight: '16px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {googleCalendarConnected ? 'Manage' : 'Set up'}
    </Button>
  )

  return (
    <SettingsBox
      icon={<GoogleCalendarIcon style={{ width: 32, height: 32 }} />}
      title="Sync blocked times from Google Calendar"
      subtitle={
        googleCalendarConnected
          ? 'Select which Google calendars to block off busy times from.'
          : 'Connect your Google Calendar in Google Calendar Settings to get started.'
      }
      action={actionManage}
    >
      {googleCalendarConnected && (
        <SyncedCalendarPicker onChange={onIntegrationChange} />
      )}
    </SettingsBox>
  )
}

const withCalendarConnectedStatus = Component => props => {
  const { data, loading } = useQuery(GET_CURRENT_USER_CALENDAR_CONNECTED_STATUS)
  if (loading) return <LinearProgress />
  return (
    <Component
      googleCalendarConnected={
        data?.currentUser?.attributes.googleCalendarConnected
      }
      {...props}
    />
  )
}

export default withCalendarConnectedStatus(GoogleCalendarIntegration)
